var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "handle",
    staticStyle: {
      "cursor": "grab"
    },
    attrs: {
      "icon": "",
      "tile": "",
      "width": "40",
      "min-height": "40",
      "height": "100%"
    }
  }, [_c('v-icon', [_vm._v("mdi-drag")])], 1)], 1), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.types,
      "solo": "",
      "flat": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  })], 1), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', [_c('tags-data', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "tile": "",
      "width": "40",
      "min-height": "40",
      "height": "100%",
      "color": "red"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('pull', _vm.form);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)], 1), _vm.showsDivider ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }